import * as moment from 'moment-timezone';

export const addPragueTz = (date: Date) => {
  const utcDate = moment(date).tz('Europe/Prague').toDate();
  return utcDate
};


// WEBPACK FOOTER //
// ./src/utils/timezone.ts